// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2guVe","actionsCol":"EnrolledClinics_actionsCol__1ZJpv"};